var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "view--presales"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('PageTitle', {
    attrs: {
      "title": "Presales",
      "icon": "pe-7s-hourglass"
    }
  })], 1), _c('div', {
    staticClass: "page-body"
  }, [_vm.navTabsVisible ? [_c('b-row', [_c('b-col', [_c('TabCollection', {
    attrs: {
      "tabs": _vm.navTabs
    }
  })], 1)], 1)] : _vm._e(), _c('router-view')], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }